import React, { useEffect} from "react";
import { useLocation, useHistory } from 'react-router-dom';
import heartIcon from '../../assets/images/heart.png'

const ThankYouPage = ({ titleProp, textProp }) => {
  const location = useLocation();
  let history = useHistory();
  const { title, text } = location.state || {};

  useEffect(() => {
    const timer = setTimeout(() => {
      history.push("/"); 
    }, 5000);

    return () => clearTimeout(timer); 
  }, [history]);

  return (
    <div className='thankyou-page'>
      <div className='thankyou-page-content'>
        <img src={heartIcon} alt='Heart Icon' />
        <div className="thankyou-title">{title || titleProp}</div>
        <div className="thankyou-text">{text || textProp}</div>
      </div>
    </div>
  );
};

export default ThankYouPage;